<template>
    <!-- 暂时没有用到 -->
    <!-- vue 模板未改造完成 -->
    <!-- <div v-if="false"
        class="carsItem carItem #if({{ data.userDefinedStatus }}=='ALREADY_RESERVED') already_reserved #end"
        data-id="{{ data.id }}">
        <a href="/car/{{ data.id }}"
            target="_blank"
            class="carImg">
            <img 
                src="//res.souche.com/images/fed/zhanwei.png" data-original="$carImgUrlUtil.formatUrl({{ data.bigImage }},279,186)$!{widgetUtil.getWaterMark({{ data.bigImage }},'%7C',279,13)}" 
                alt="{{ data.fullName }}"
                width="325px"
                style="display: inline; width: 100%; height: auto;">
            <div class="timebuy hidden"></div>
        </a>
        <a href="/car/{{ data.id }}"
            target="_blank"
            class="car-link">$!item.fullName </a>
        <div class="car-price">
            <span class="price">
            #if($!item.consignment!=1)
                <span class="price-amount">$!item.price</span> #else
                <span class="price-amount">首付$!item.prepaidLeaseAmount万</span> #*
                <span class="price-amount">月供$!item.installmentPayment元</span>*#
                <img src="//img.souche.com/20161213/png/e4ca1def296c54355b13e761b29da194.png" width="65px" style="display: inline;" /> #end
            </span>
        </div>
        <div class="car-info">
            <span class="info-item">$!item.year</span>
            <em>|</em>
            <span class="info-item">$!item.mileage万公里</span>
            <em>|</em>
            <span class="info-item">
                <span class="info-item-name">归属地:</span>
                $!item.cityName
            </span>
        </div>
        <div class="carTail clearfix">
            <a data-carid="{{ data.id }}"
                data-shopid="{{ data.shopId }}"
                click_type="sale-favs"
                data-num="{{ data.collectCount }}"
                title="收藏 {{ data.collectCount }}"
                class="fav collect #if({{ data.collected }})colled#end">
                <span class="add-to-coll">收藏</span>
                <span class="already-colled">已收藏</span>
                <span class="fav-count" data-favcount="{{ data.collectCount }}">{{ data.collectCount }}</span>
            </a>
        </div>
    </div> -->
</template>
<script>
export default {
    props: ['data']
};
</script>
<style lang="less" scoped>
/** 这里占位，车辆组件样式不需要全局使用时，迁移到这里 */
</style>
<style lang="less">
/** 这里用于提高优先级 */
.list-box.list-box .carItem {
    position: relative;
    margin-left: 20px;
    height: 160px;
    padding: 20px 0;
    border-bottom: 1px solid #EDEDED;
    box-sizing: border-box;
    * {
        box-sizing: border-box;
    }
    .carImg {
        float: left;
        margin-right: 20px;
        width: 180px;
        height: 120px;
        img {
            width: 100%;
        }
    }
    .car-link {
        font-size: 14px;
        display: inline-block;
        margin-bottom: 8px;
        line-height: 20px;
        width: auto;
        max-width: 290px;
        margin-left: 0;
    }
    .car-price {
        position: absolute;
        left: 575px;
        top: 20px;
        height: 120px;
        width: 200px;
        .price {
            display: block;
            margin-bottom: 6px;
            color: #ff5517;
        }
        .price-amount {
            font-family: 'Tahoma';
            font-weight: bold;
            font-size: 16px;
        }

    }
    .tangeche-logo {
        height: 16px;
        img {
            height: 16px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// CarItemForList.vue?56a69432